export default __webpack_public_path__ + "static/media/bathroom1-before-480w.837e563b.avif";